import { useQuery } from '@tanstack/react-query';
import { useDispatch } from 'react-redux';
import { useEffect } from 'react';
import { v2UserDetails } from 'src/common/Scraper';
import {
  stateUserDetails,
  setIsLoadingUserDetails
} from 'src/redux/counterSlice';
import { setTermModal } from 'src/redux/siteAuditReducer';

const QUERY_KEY = 'userDetails';

interface UseUserDetailsProps {
  enabled?: boolean;
  refetchInterval?: number;
  refetch?: boolean;
}

const DEFAULT_REFETCH_INTERVAL = 5000;

export const useUserDetails = ({
  enabled = true,
  refetchInterval,
  refetch
}: UseUserDetailsProps = {}) => {
  const dispatch = useDispatch();
  const query = useQuery({
    queryKey: [QUERY_KEY],
    queryFn: async () => {
      dispatch(setIsLoadingUserDetails(true));
      try {
        const response: any = await v2UserDetails();
        return response;
      } finally {
        dispatch(setIsLoadingUserDetails(false));
      }
    },
    enabled: enabled,
    refetchInterval: refetch
      ? refetchInterval || DEFAULT_REFETCH_INTERVAL
      : false
  });

  useEffect(() => {
    if (query.data) {
      dispatch(stateUserDetails(query.data));
      dispatch(setTermModal(query?.data?.has_agreed_to_terms));
    }
  }, [query.data, dispatch]);

  return query;
};
